import React, { useEffect, useRef, useState } from "react"

const UploadInput = ({
	className = "",
	onFileSelect,
	placeholderIcon = "/assets/icons/icon-add-photo.svg",
	placeholderTitle = "Upload image",
	placeholderText = "drag or drop PNG or JPG",
	acceptedTypes = "image/*",
	titleClassName = "",
	subtitleClassName = "",
	iconClassName = "",
	editTimes = 0,
	defaultPreview = null,
	uploadId = "upload-input",
	onFileRemove = () => { },
	id = 0,
	...props
}) => {
	const [preview, setPreview] = useState(defaultPreview)
	const [isDragging, setIsDragging] = useState(false)
	const fileInputRef = useRef(null)

	useEffect(() => {
		if (editTimes > 0 && fileInputRef.current) {
			fileInputRef.current.click()
		}
	}, [editTimes])

	useEffect(() => {
		if (typeof defaultPreview === "string") {
			setPreview(defaultPreview)
		}
	}, [defaultPreview])

	const handleFileChange = (e) => {
		const file = e.target.files[0]
		if (file) {
			setPreview(URL.createObjectURL(file))
			if (onFileSelect) onFileSelect(file)
		}
	}

	const handleDrop = (e) => {
		e.preventDefault()
		setIsDragging(false)
		const file = e.dataTransfer.files[0]
		if (file) {
			setPreview(URL.createObjectURL(file))
			if (onFileSelect) onFileSelect(file)
		}
	}

	const handleDragOver = (e) => {
		e.preventDefault()
		setIsDragging(true)
	}

	const handleDragLeave = (e) => {
		e.preventDefault()
		setIsDragging(false)
	}

	return (
		<div
			className={`relative border-[1px] border-gray bg-white/5 backdrop-blur-sm flex flex-col justify-center items-center text-center cursor-pointer transition-all duration-200 ${
				isDragging ? "border-primary bg-gray-700" : ""
			} ${className}`}
			onDrop={handleDrop}
			onDragOver={handleDragOver}
			onDragLeave={handleDragLeave}
			{...props}
		>
			<input
				type="file"
				accept={acceptedTypes}
				onChange={handleFileChange}
				style={{ display: "none" }}
				id={uploadId}
				ref={fileInputRef}
			/>

			{preview ? (
				<>
					<button
						className="absolute right-0 w-[20px] h-[20px] rounded-full bg-white top-0 -mr-2 -mt-2 z-[20]"
						onClick={(e) => {
							e.stopPropagation()
							setPreview(null)
							onFileRemove(id)
						}}
					>
						<img src="/assets/icons/icon-close.svg" alt="close" />
					</button>

					<img
						src={preview}
						alt="Preview"
						className="w-full h-full object-cover"
					/>
				</>
			) : null}

			<label
				htmlFor={uploadId}
				className="absolute flex flex-col items-center justify-center z-10 w-full h-full cursor-pointer"
			>
				{!preview && (
					<div className="flex items-center flex-col gap-y-3 text-gray-100 text-xs">
						<img src="/assets/icons/icon-upload.svg" alt="icon-upload" />
						Add Img PNG, JPG
					</div>
				)}
			</label>
		</div>
	)
}

export default UploadInput
